<template>
  <a href="#" @click.prevent="handleClick">
  <div class="project-card">
      <img
        :src="getImageSrc"
        :alt="header"
        class="card-image"
      />
    <div class="card-content">
      <div class="text-container">
          <div class="header">{{ header }}</div>
        <p class="description">
            {{ description }}
        </p>
      </div>
      <div class="skill-badges">
          <div 
            v-for="(row, rowIndex) in badgeRows" 
            :key="rowIndex"
            class="badge-row"
          >
            <SkillBadge 
              v-for="(badgeText, index) in row" 
              :key="index"
              :text="badgeText" 
            />
          </div>
      </div>
    </div>
  </div>
  </a>
</template>

<script>
import SkillBadge from "./SkillBadge.vue";
export default {
  name: "ProjectCard",
  components: {
    SkillBadge,
  },
  props: {
    header: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    badges: {
      type: Array,
      required: true,
      default: () => [],
    },
    imageSrc: {
      type: String,
      required: true,
    },
  },
  computed: {
    getImageSrc() {
      // Если путь начинается с @/, используем require для правильной обработки
      if (this.imageSrc.startsWith('@/')) {
        const path = this.imageSrc.replace('@/', '');
        try {
          return require(`@/${path}`);
        } catch (e) {
          return this.imageSrc;
        }
      }
      return this.imageSrc;
    },
    badgeRows() {
      const rows = [];
      for (let i = 0; i < this.badges.length; i += 3) {
        rows.push(this.badges.slice(i, i + 3));
      }
      return rows;
    }
  },
  methods: {
    handleClick() {
      const message = this.$t("contact.productMessage", {
        title: this.header,
      });
      const url = `https://t.me/zeroliquid_manager?text=${encodeURIComponent(
        message
      )}`;
      window.open(url, "_blank");
    },
  },
};
</script>

<style scoped>
a {
    text-decoration: none;
    color: #FFF;
    transition: all 0.25s;
}

a:hover .card-image {
    opacity: 0.5;
    transition: all 0.25s;
}

.project-card {
    position: relative;
}

.card-content {
    position: absolute;
    bottom: 0;
    left: 0;
  padding: clamp(24px, 2.5vw, 48px);
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
  align-items: end;
}

.card-image {
  width: 100%;
  border-radius: clamp(16px, 1.67vw, 32px);
  transition: opacity 0.3s ease;
}

.skill-badges {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  width: 50%;
}

.badge-row {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.badge-row > * {
  margin: 0;
  line-height: 1;
}

.text-container {
  width: 40%;
}

.header {
  font-size: clamp(17px, 2.29vw, 44px);
  font-weight: 400;
}

.description {
  font-size: clamp(9px, 0.94vw, 18px);
  font-weight: 400;
  margin: 0;
  margin-top: clamp(4px, 0.42vw, 8px);
}

@media screen and (max-width: 846px) {
  .card-content {
    flex-direction: column;
    gap: 32px;
  }

  .text-container {
    width: 100%;
  }

  .skill-badges {
    align-items: start;
    width: 100%;
  }
}
</style>
